import { closeSession } from '@/services/session/session'
import Toast from '../elements/toast'
import { logout } from '@/store/features/auth'
import { AppDispatch } from '@/store/store'
import { NavigateFunction } from 'react-router-dom'

const logoutDashboard = (dispatch: AppDispatch, navigate: NavigateFunction, message : string = 'Session cerrada exitosamente') => {
	dispatch(logout())
	closeSession()
	navigate('/')
	Toast({ type: 'info', message: message })
}

export default logoutDashboard
